"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Camera = function Camera(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M12.5 9.896C11.985 9.896 11.4815 10.0487 11.0532 10.3349C10.625 10.621 10.2912 11.0277 10.0941 11.5036C9.89697 11.9794 9.8454 12.5031 9.94588 13.0082C10.0464 13.5134 10.2944 13.9774 10.6586 14.3416C11.0228 14.7058 11.4868 14.9538 11.992 15.0543C12.4971 15.1548 13.0207 15.1032 13.4966 14.9061C13.9724 14.709 14.3791 14.3752 14.6653 13.947C14.9514 13.5187 15.1042 13.0152 15.1042 12.5002C15.1034 11.8097 14.8288 11.1478 14.3406 10.6596C13.8524 10.1714 13.1904 9.89676 12.5 9.896ZM12.5 14.0627C12.191 14.0627 11.8889 13.971 11.6319 13.7993C11.375 13.6276 11.1747 13.3836 11.0564 13.0981C10.9382 12.8126 10.9072 12.4984 10.9675 12.1953C11.0278 11.8922 11.1766 11.6138 11.3952 11.3953C11.6137 11.1768 11.8921 11.028 12.1952 10.9677C12.4983 10.9074 12.8124 10.9383 13.098 11.0566C13.3835 11.1749 13.6275 11.3751 13.7992 11.6321C13.9709 11.889 14.0625 12.1911 14.0625 12.5002C14.062 12.9144 13.8973 13.3116 13.6043 13.6045C13.3114 13.8974 12.9143 14.0622 12.5 14.0627Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18.75 7.81258H15.1042V6.25008C15.1042 6.11195 15.0493 5.97947 14.9516 5.8818C14.8539 5.78412 14.7215 5.72925 14.5833 5.72925H10.4167C10.2785 5.72925 10.1461 5.78412 10.0484 5.8818C9.95071 5.97947 9.89584 6.11195 9.89584 6.25008V7.81258H6.25001C6.11187 7.81258 5.9794 7.86745 5.88172 7.96513C5.78405 8.0628 5.72917 8.19528 5.72917 8.33341V16.6667C5.72917 16.8049 5.78405 16.9374 5.88172 17.035C5.9794 17.1327 6.11187 17.1876 6.25001 17.1876H18.75C18.8881 17.1876 19.0206 17.1327 19.1183 17.035C19.216 16.9374 19.2708 16.8049 19.2708 16.6667V8.33341C19.2708 8.19528 19.216 8.0628 19.1183 7.96513C19.0206 7.86745 18.8881 7.81258 18.75 7.81258ZM10.9375 6.77091H14.0625V7.81258H10.9375V6.77091ZM18.2292 16.1459H6.77084V8.85425H18.2292V16.1459Z",
    fill: props.foregroundColor
  }));
};

Camera.defaultProps = {
  altText: "Camera",
  foregroundColor: "#2D5AB4"
};
Camera.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Camera;
exports.default = _default;